import { render, staticRenderFns } from "./ClearData.vue?vue&type=template&id=4ec14680&"
import script from "./ClearData.vue?vue&type=script&lang=js&"
export * from "./ClearData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports